import { type Icon } from '@tabler/icons-react';

export const SbpIcon: Icon = ({ size = 24, width = size, height = size, ...svgProps }) => {
    return (
        <svg
            {...svgProps}
            width={width}
            height={height}
            viewBox='0 0 98 120'
            fill='none'
            stroke='none'
            preserveAspectRatio='xMidYMid meet'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0 26.12l14.532 25.975v15.844L.017 93.863 0 26.12z'
                fill='#5B57A2'
            />

            <path
                d='M55.797 42.643l13.617-8.346 27.868-.026-41.485 25.414V42.643z'
                fill='#D90751'
            />

            <path
                d='M55.72 25.967l.077 34.39-14.566-8.95V0l14.49 25.967z'
                fill='#FAB718'
            />

            <path
                d='M97.282 34.271l-27.869.026-13.693-8.33L41.231 0l56.05 34.271z'
                fill='#ED6F26'
            />

            <path
                d='M55.797 94.007V77.322l-14.566-8.78.008 51.458 14.558-25.993z'
                fill='#63B22F'
            />

            <path
                d='M69.38 85.737L14.531 52.095 0 26.12l97.223 59.583-27.844.034z'
                fill='#1487C9'
            />

            <path
                d='M41.24 120l14.556-25.993 13.583-8.27 27.843-.034L41.24 120z'
                fill='#017F36'
            />

            <path
                d='M.017 93.863l41.333-25.32-13.896-8.526-12.922 7.922L.017 93.863z'
                fill='#984995'
            />
        </svg>
    );
};
